import React from 'react'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import useIsMobile from 'components/program-marketing/useIsMobile'

const useStyles = makeStyles(() => ({
  flex: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  mobileLayout: {
    marginBottom: '2rem',
    gap: '6px',
    flexDirection: 'column',
  },
}))

const HeaderSubText = ({ children }) => {
  const isMobile = useIsMobile()
  const classes = useStyles()
  return (
    <Typography
      variant="body1"
      className={clsx(classes.flex, isMobile && classes.mobileLayout)}
      gutterBottom
    >
      <span>{children}</span>
    </Typography>
  )
}

HeaderSubText.propTypes = {
  children: PropTypes.string,
}

export default HeaderSubText
